import { useState, useEffect } from 'react';
import FullQualifiedClientId from '../../../Various/FullQualifiedClientId';
import useStickyState from '../../../../functions/useStickyState';

export const useCampaignData = (wsProvider, projectId, projectPath, tableValues, setTableValues) => {
    const [campaignData, setCampaignData] = useState(null);
    const [clientCampaignsTree, setClientCampaignsTree] = useState({}); // Lightweight data for tree
    const [clientCampaignsOverview, setClientCampaignsOverview] = useState({}); // Full data with history and billing for overview/invoices/reports tabs

    const convertDatesToTimestamps = (campaign) => {
        const convertedCampaign = { ...campaign };
        if (convertedCampaign.campaign_start_date) {
            convertedCampaign.campaign_start_date = (new Date(convertedCampaign.campaign_start_date)).getTime() / 1000;
        }
        if (convertedCampaign.campaign_end_date) {
            convertedCampaign.campaign_end_date = (new Date(convertedCampaign.campaign_end_date)).getTime() / 1000;
        } else {
            convertedCampaign.campaign_end_date = null;
        }
        return convertedCampaign;
    };

    const convertTimestampsToDates = (campaign) => {
        const convertedCampaign = { ...campaign };
        if (convertedCampaign.campaign_start_date && typeof convertedCampaign.campaign_start_date === 'number') {
            convertedCampaign.campaign_start_date = (new Date(convertedCampaign.campaign_start_date * 1000)).toISOString();
        } else {
            convertedCampaign.campaign_start_date = "";
        }
        if (convertedCampaign.campaign_end_date && typeof convertedCampaign.campaign_end_date === 'number') {
            convertedCampaign.campaign_end_date = (new Date(convertedCampaign.campaign_end_date * 1000)).toISOString();
        } else {
            convertedCampaign.campaign_end_date = "";
        }
        return convertedCampaign;
    };

    const loadCampaignData = (campaign_id, client_id) => {
        if (campaign_id === undefined || campaign_id === null) {
            return;
        }
        
        wsProvider.ws.waitForSocketAndSend({
            action: "getCampaign",
            options: {
                campaign_id: campaign_id,
                client_id: client_id
            }
        }, (response) => {
            if (response.campaign) {
                setCampaignData(convertTimestampsToDates(response.campaign));
            }
        });
    };

    const saveCampaign = () => {
        wsProvider.ws.waitForSocketAndSend({
            action: "saveCampaign",
            options: {
                campaign: convertDatesToTimestamps(campaignData)
            }
        }, (response) => {
            console.log("Saved Campaign");
        });
    };

    const publishCampaign = () => {
        wsProvider.ws.waitForSocketAndSend({
            action: "publishCampaign",
            options: {
                campaign: convertDatesToTimestamps(campaignData)
            }
        }, () => {
            console.log("Published Campaign");
        });
    };

    // Load lightweight campaigns data for tree
    const loadAllCampaigns = () => {
        wsProvider.ws.waitForSocketAndSend({
            action: "getAllCampaigns",
            options: {
                project_id: projectId,
                project_path: projectPath,
            }
        }, (response) => {
            setClientCampaignsTree(response.client_campaigns || {});
        });
    };

    // Load full campaigns data with history and billing for overview/invoices/reports tabs
    const loadAllCampaignsWithHistoryAndOpenBillingData = (callback) => {
        wsProvider.ws.waitForSocketAndSend({
            action: "getAllCampaignsWithHistoryAndOpenBillingData",
            options: {
                project_id: projectId,
                project_path: projectPath,
            }
        }, (response) => {
            setClientCampaignsOverview(response.client_campaigns || {});
            if (callback) {
                callback(response);
            }
        });
    };

    // Auto-load lightweight campaigns for tree when project changes
    useEffect(() => {
        if (projectId && projectPath) {
            loadAllCampaigns();
        }
    }, [projectId, projectPath]);

    return {
        campaignData,
        setCampaignData,
        clientCampaignsTree,
        setClientCampaignsTree,
        clientCampaignsOverview,
        setClientCampaignsOverview,
        loadCampaignData,
        saveCampaign,
        publishCampaign,
        loadAllCampaigns,
        loadAllCampaignsWithHistoryAndOpenBillingData,
        convertTimestampsToDates,
        convertDatesToTimestamps
    };
}; 